/**
 * Deep link interno: #/p/{productId} y #/perfil-vendedor/{uid}.
 */

/** UID Firebase desde `#/perfil-vendedor/{uid}` (publicaciones por UID). */
export function parseMlvHashPerfilVendedorUid() {
  if (typeof window === 'undefined') return null;
  const hash = window.location.hash || '';
  const m = hash.match(/^#\/perfil-vendedor\/([^/?#]+)/);
  if (!m) return null;
  let raw;
  try {
    raw = decodeURIComponent(m[1]).trim();
  } catch {
    raw = String(m[1] || '').trim();
  }
  if (!/^[A-Za-z0-9_-]{10,128}$/.test(raw)) return null;
  return raw;
}

/**
 * `#/servicios`, `#/servicios/mi-perfil`, `#/servicios/pro/{uid}`
 * @returns {{ t: 'servicios', mode: 'home' } | { t: 'servicios', mode: 'miPerfil' } | { t: 'servicios', mode: 'ficha', uid: string } | null}
 */
export function parseMlvHashServiciosRoute() {
  if (typeof window === 'undefined') return null;
  const hash = window.location.hash || '';
  const m = hash.match(/^#\/servicios(?:\/([^/?#]+)(?:\/([^/?#]+))?)?$/);
  if (!m) return null;
  const a = m[1] ? String(m[1]).trim() : '';
  const b = m[2] ? String(m[2]).trim() : '';
  if (!a) return { t: 'servicios', mode: 'home' };
  if (a === 'mi-perfil') return { t: 'servicios', mode: 'miPerfil' };
  if ((a === 'pro' || a === 'u') && b && /^[A-Za-z0-9_-]{10,128}$/.test(b)) {
    return { t: 'servicios', mode: 'ficha', uid: b };
  }
  return null;
}

export function parseMlvHashProductId() {
  if (typeof window === 'undefined') return null;
  const hash = window.location.hash || '';
  const m = hash.match(/^#\/p\/([^/?#]+)/);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]).trim() || null;
  } catch {
    return String(m[1] || '').trim() || null;
  }
}

/**
 * ID de producto desde URL canónica (#/p/id, /p/id, ?p=) o ID suelto (admin).
 */
export function parseMlvProductIdFromUrlOrRaw(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  if (/^[A-Za-z0-9_-]{10,128}$/.test(s) && !s.includes('/') && !s.includes('.')) return s;
  try {
    const u = new URL(s, /^https?:\/\//i.test(s) ? undefined : 'https://lavictoria-market.local');
    const hm = (u.hash || '').match(/#\/p\/([^/?#]+)/);
    if (hm) {
      try {
        return decodeURIComponent(hm[1]).trim() || null;
      } catch {
        return String(hm[1] || '').trim() || null;
      }
    }
    const pm = u.pathname.match(/\/p\/([^/]+)/);
    if (pm) {
      try {
        return decodeURIComponent(pm[1]).trim() || null;
      } catch {
        return String(pm[1] || '').trim() || null;
      }
    }
    const qp = u.searchParams.get('p') || u.searchParams.get('producto');
    if (qp) {
      try {
        return decodeURIComponent(String(qp).trim()) || null;
      } catch {
        return String(qp).trim() || null;
      }
    }
  } catch (_e) {
    /* seguir */
  }
  const hm = s.match(/#\/p\/([^/?#]+)/);
  if (hm) {
    try {
      return decodeURIComponent(hm[1]).trim() || null;
    } catch {
      return String(hm[1] || '').trim() || null;
    }
  }
  return null;
}

/**
 * Algunos navegadores / in-app pierden el hash; `/p/{id}` llega al servidor y el rewrite
 * sirve index.html. Convierte path o query `?p=` / `?producto=` a `#/p/{id}` en la raíz.
 */
export function normalizeMlvProductEntryFromLocation() {
  if (typeof window === 'undefined') return;
  try {
    const u = new URL(window.location.href);
    const pm = u.pathname.match(/^\/p\/([^/]+)\/?$/);
    let rawId = pm ? String(pm[1] || '').trim() : '';
    if (rawId) {
      try {
        rawId = decodeURIComponent(rawId);
      } catch {
        /* usar segmento tal cual */
      }
    }
    if (!rawId) {
      rawId = String(u.searchParams.get('p') || u.searchParams.get('producto') || '').trim();
    }
    if (!rawId) return;
    const enc = encodeURIComponent(rawId);
    const wantHash = `#/p/${enc}`;
    if (pm) u.pathname = '/';
    u.searchParams.delete('p');
    u.searchParams.delete('producto');
    u.hash = wantHash;
    const next = `${u.pathname}${u.search}${u.hash}`;
    if (next !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
      window.history.replaceState(window.history.state, '', next);
    }
  } catch (_e) {
    /* ignore */
  }
}

/** Path `/perfil-vendedor/{uid}` → hash `#/perfil-vendedor/{uid}` */
export function normalizeMlvPerfilVendedorEntryFromLocation() {
  if (typeof window === 'undefined') return;
  try {
    const u = new URL(window.location.href);
    const pm = u.pathname.match(/^\/perfil-vendedor\/([^/]+)\/?$/);
    if (!pm) return;
    let seg = String(pm[1] || '').trim();
    try {
      seg = decodeURIComponent(seg);
    } catch {
      /* ok */
    }
    if (!/^[A-Za-z0-9_-]{10,128}$/.test(seg)) return;
    u.pathname = '/';
    u.hash = `#/perfil-vendedor/${encodeURIComponent(seg)}`;
    const next = `${u.pathname}${u.search}${u.hash}`;
    if (next !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
      window.history.replaceState(window.history.state, '', next);
    }
  } catch (_e) {
    /* ignore */
  }
}
